<script setup lang="ts">
  import { useSnackBarStore } from "~/stores/SnackBarStore";

  interface Props {
    url: string | null;
  }
  const props = defineProps<Props>();

  // スナックバーstore
  const snackBarStore = useSnackBarStore();

  const copyText = () => {
    if (!props.url) {
      return;
    }
    let url = `${window.location.host}${props.url}`;
    url = url.includes("localhost") ? `http://${url}` : `https://${url}`;
    navigator.clipboard.writeText(url);
    snackBarStore.set("クリップボードにコピーしました");
  };
</script>

<template>
  <div class="copy-button d-flex" :class="{ disabled: !props.url }" @click="copyText">
    <v-icon icon="$mdiLinkVariant" size="x-large" />
  </div>
</template>
<style lang="scss" scoped>
  .copy-button {
    cursor: pointer;
    border-radius: 15px;
    height: 30px;
    padding: 5px 12px;
    font-size: 10px;
    font-weight: 700;
    line-height: 24px; // アイコンがズレるので個別に指定
    background-color: rgb(var(--v-theme-monochrome-03));
  }
  .disabled {
    cursor: not-allowed;
    color: rgb(var(--v-theme-monochrome-02));
  }
</style>
